import { IUserData } from 'types/users'
import {
  SortBemsType,
  SortDocumentosType,
  SorteGruposType,
  SortFlexProposalsType,
  SortManagementProposalsType,
  SortPubliCardsType
} from 'types/sortFunctions'
import { naturalSort, sortStrings } from './utils'

export const sortDocuments: SortDocumentosType = {
  cd_inscricao_nacional: (a, b) => sortStrings(a.cd_inscricao_nacional, b.cd_inscricao_nacional),
  proposal: (a, b) => b.id_documento - a.id_documento,
  newest: (a, b) => new Date(b.dt_venda).getTime() - new Date(a.dt_venda).getTime(),
  oldest: (a, b) => new Date(a.dt_venda).getTime() - new Date(b.dt_venda).getTime()
}

export const sortFlexProposals: SortFlexProposalsType = {
  document: (a, b) => Number(a.cd_inscricao_nacional) - Number(b.cd_inscricao_nacional),
  newest: (a, b) =>
    new Date(b.dt_ultima_alteracao).getTime() - new Date(a.dt_ultima_alteracao).getTime(),
  oldest: (a, b) =>
    new Date(a.dt_ultima_alteracao).getTime() - new Date(b.dt_ultima_alteracao).getTime()
}

export const sortManagementProposals: SortManagementProposalsType = {
  cd_inscricao_nacional: (a, b) => sortStrings(a.cd_inscricao_nacional, b.cd_inscricao_nacional),
  proposal: (a, b) => b.id_documento - a.id_documento,
  newest: (a, b) => new Date(b.dt_venda).getTime() - new Date(a.dt_venda).getTime(),
  oldest: (a, b) => new Date(a.dt_venda).getTime() - new Date(b.dt_venda).getTime()
}

export const sortGroups: SorteGruposType = {
  menorLanceContemplado: (a, b) => a.pe_menor_lance - b.pe_menor_lance,
  minValue: (a, b) => a.vl_bem_inicial - b.vl_bem_inicial,
  maxValue: (a, b) => b.vl_bem_inicial - a.vl_bem_inicial,
  cdGrupo: (a, b) => sortStrings(a.cd_grupo, b.cd_grupo)
}

export const sortBems: SortBemsType = {
  minValue: (a, b) => a.vl_bem - b.vl_bem,
  maxValue: (a, b) => b.vl_bem - a.vl_bem
}

export const sortPubliCards: SortPubliCardsType = {
  document: (a, b) => sortStrings(a.nm_campanha, b.nm_campanha),

  newest: (a, b) => new Date(b.dt_iv_campanha).getTime() - new Date(a.dt_iv_campanha).getTime(),
  oldest: (a, b) => new Date(a.dt_iv_campanha).getTime() - new Date(b.dt_iv_campanha).getTime()
}

type ComparadorUsuario = (a: IUserData, b: IUserData) => number
export const sortUserCards: { [key: string]: ComparadorUsuario } = {
  nm_pessoa: (a, b) => sortStrings(a.nm_pessoa, b.nm_pessoa),
  cd_inscricao_nacional: (a, b) => naturalSort(a.cd_inscricao_nacional, b.cd_inscricao_nacional),
  cd_usuario: (a, b) => sortStrings(a.cd_usuario, b.cd_usuario)
}
